import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

import type {
  CreateEnvelopeAccessLinkRequest,
  CreateEnvelopeAccessLinkResponse,
} from './access-links.types'
import { ENVELOPE_ACCESS_LINKS_QUERY_KEY } from './use-list-envelope-access-links'

const createEnvelopeAccessLink = async (
  envelopeId: string,
  request: CreateEnvelopeAccessLinkRequest,
): Promise<CreateEnvelopeAccessLinkResponse> => {
  const response = await apiClient.post<CreateEnvelopeAccessLinkResponse>(
    `/v1/ecm/envelopes/${envelopeId}/access-links`,
    request,
  )
  return response.data
}

export const useCreateEnvelopeAccessLink = (
  envelopeId: string,
  feedback?: MutationFeedback,
) => {
  return useMutation({
    mutationFn: (request: CreateEnvelopeAccessLinkRequest) =>
      createEnvelopeAccessLink(envelopeId, request),
    meta: { invalidatesQuery: ENVELOPE_ACCESS_LINKS_QUERY_KEY, ...feedback },
  })
}
